import React from 'react'
import TransferSdk from "@smash-sdk/transfer/ejs/07-2022";
import { Badge } from 'react-bootstrap';

export interface Props {
    status: TransferSdk.GetTransferOutput['transfer']['status']
}

const TransferStatus = (props: Props) => {
  const humanizedStatus = (value:TransferSdk.GetTransferOutput['transfer']['status']): {color: string; value:string} => {
    switch(value) {
        case 'Uploading':        
            return { color: 'success', value: 'Uploading'};
        case 'Processing':
            return { color: 'success', value: 'Processing'};
        case 'Uploaded':
            return { color: 'success', value: 'Active'};
        case 'Deleting':
            return { color: 'danger', value: 'Deleting'};
        case 'Deleted':
            return { color: 'danger', value: 'Deleted'};
        case 'Expired':
            return { color: 'secondary', value: 'Expired'};
        case 'Suspended':
            return { color: 'danger', value: 'Suspended'};
        case 'Dirty':
            return { color: 'info', value: 'Dirty'};
    } 
  }
    
  const { color, value} = humanizedStatus(props.status);

  return (
    <><Badge bg={color}>{value}</Badge></>
  )
}

export default TransferStatus